export { getDataFromMultipleFirstStep } from "./getDataFromMultipleFirstStep";
export { getDataFromMultipleSecondStep } from "./getDataFromMultipleSecondStep";
